import { Card, Grid } from "@mui/material";
import { AppWidgetSummary } from "src/sections/@dashboard/app";
import UsersSignupChart from "../users/UsersSignupChart";
import { STATS } from "src/_mock/stats";

export default function VersusStats(props) {
  return (
    <Card sx={{ p: 2, mb: 5 }}>
      <Grid container sx={{ mb: 2 }} spacing={1}>
        <Grid item xs={12} md={6} lg={6}>
          <UsersSignupChart
            title="Spent Per Day"
            subheader=""
            height={380}
            chartLabels={props.stats.entryAmountsPerDay.map(
              (date) => date.date
            )}
            chartData={[
              {
                name: "Spent",
                type: "column",
                fill: "solid",
                data: props.stats.entryAmountsPerDay.map((date) => date.profit),
              },
            ]}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <Grid container spacing={1}>
            {STATS.slice(0, 15).map((item, index) => (
              <Grid item xs={4} key={index}>
                <AppWidgetSummary
                  title={item.title}
                  total={props.stats[item.field]}
                  icon={"eva:behance-outline"}
                  color={item.color}
                  format={item.format}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
        {STATS.slice(15, STATS.length).map((item, index) => (
          <Grid item xs={4} md={2} lg={2} key={index}>
            <AppWidgetSummary
              title={item.title}
              total={props.stats[item.field]}
              icon={"eva:behance-outline"}
              color={item.color}
              format={item.format}
            />
          </Grid>
        ))}
      </Grid>
    </Card>
  );
}
